import { render, staticRenderFns } from "./GestoMain.vue?vue&type=template&id=5ae60ec7&"
import script from "./GestoMain.vue?vue&type=script&lang=js&"
export * from "./GestoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports